export default {
    loadMemberDetails($row) {
        if (!this.memberDetailFragmentRoute || !$row?.length) return;
        const key = this.getRowKey($row);
        const $container = this.getDetailContainer($row, key, 'member-details');
        if (!key || !$container.length) return;
        const requestKey = `member-${key.id}`;
        this.abortRequest(requestKey);
        this.setLoadingState($container, 'Loading...');
        const url = this.memberDetailFragmentRoute.replace(':member_id', key.id);
        const jqXHR = $.get(url);
        jqXHR.done((html) => {
            if (this.activeRequests[requestKey] !== jqXHR) return;
            delete this.activeRequests[requestKey];
            $container.empty().removeClass('payment-details-loading').append(html);
        }).fail((xhr) => {
            if (this.activeRequests[requestKey] !== jqXHR) return;
            delete this.activeRequests[requestKey];
            if (xhr.statusText !== 'abort') {
                this.setErrorState($container, 'Error loading. Please try again.');
            }
        });
        this.activeRequests[requestKey] = jqXHR;
    },
};
